import classNames from 'classnames';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import Button from 'components/base/Button';
import { errorHandler } from 'helpers/response-utils';
import { parseData } from 'helpers/utils';
import { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import QRCode from 'qrcode';

const Details = () => {
  const nav = useNavigate();
  const [walletList, setWalletList] = useState([]);
  const userJSON = localStorage.getItem('user');
  const token = localStorage.getItem('token');
  const [copySuccess, setCopySuccess] = useState('');
  const [qrCodeImage, setQrCodeImage] = useState('');
  const [walletBalance, setWalletBalance] = useState({
    solana: '0',
    lamports: '0'
  });
  const [wmdr, setWmdr] = useState('0');

  useEffect(() => {
    getActiveWallet();
  }, []);

  const getActiveWallet = async () => {
    const user = userJSON != null ? parseData(userJSON) : '';

    const response = await axios.get(
      `${process.env.REACT_APP_ENDPOINT}/feepayer-wallet/filter?isActive=true`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    errorHandler(response);

    if (response.data['data']['wallet'].length) {
      setWalletList(response.data['data']['wallet']);
      setWalletBalance(response.data['data']['walletBalance']);
      setWmdr(response.data['data']['wmdr']);
      setQrCodeImage(
        await QRCode.toDataURL(response.data['data']['wallet'][0]['fpAddress'])
      );
    }
  };

  const handleCopy = () => {
    const address = walletList?.[0]['fpAddress'];
    if (!address) return;

    navigator.clipboard
      .writeText(address)
      .then(() => {
        setCopySuccess('Copied!');
        setTimeout(() => setCopySuccess(''), 2000);
      })
      .catch(() => setCopySuccess('Failed to copy'));
  };

  const navigateToCreateWallet = () => {
    nav('/feepayer-wallet/generate');
  };
  return (
    <div>
      <div className="mb-6">
        <Row className="g-3 justify-content-between mb-4">
          <Col xs="auto">
            <h2>Fee Payer Wallet</h2>
          </Col>
          <Col xs="auto">
            <div className="d-flex">
              <Button
                variant="primary"
                className="me-4"
                startIcon={<FontAwesomeIcon icon={faPlus} className="me-2" />}
                onClick={navigateToCreateWallet}
              >
                Fee Payer Wallet
              </Button>
            </div>
          </Col>
        </Row>
        {walletList.length ? (
          <Row>
            <Col className="col-6">
              <Card>
                <Card.Body>
                  <Row className={classNames('g-3', 'mb-6')}>
                    <Col sm={12} md={12}>
                      <span>Name</span>
                      <p>{walletList[0]['name']}</p>
                    </Col>

                    <Col sm={12} md={12}>
                      Description
                      <p>{walletList[0]['description']}</p>
                    </Col>

                    <Col sm={12} md={12}>
                      Wallet address
                      <p>
                        <Button variant="secondary" onClick={handleCopy}>
                          {walletList[0]['fpAddress']}
                        </Button>
                        {copySuccess && (
                          <span className="ms-2">{copySuccess}</span>
                        )}
                      </p>
                    </Col>
                    <Col sm={12} md={12}>
                      Wallet Balance
                      <p>
                        <b>{walletBalance?.solana}</b> SOL
                      </p>
                    </Col>
                    <Col sm={12} md={12}>
                      WMDR Balance
                      <p>
                        <b>{wmdr}</b> WMDR
                      </p>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
            <Col className="col-6">
              <Card>
                <Card.Body>
                  <Row>
                    <Col sm={12} md={12}>
                      <a
                        href={qrCodeImage}
                        download={walletList[0]['fpAddress']}
                      >
                        <img src={qrCodeImage} alt="" className="w-50" />
                      </a>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col className="col-6">
              <p>No Record Found</p>
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
};

export default Details;
